import { IFloorDetails, IPortfolioCity, IPortfolioRegion } from '@api'

const getFavoriteFloorsFromRegions = (regions: IPortfolioRegion[], favoriteFloors: string[]) =>
  regions.reduce<IFloorDetails[]>((regionsAcc, item) => {
    return [...regionsAcc, ...getCities(item, favoriteFloors)]
  }, [])

const getBuildings = (city: IPortfolioCity, favoriteFloors: string[]) => {
  return city.buildings.reduce<IFloorDetails[]>((buildingsAcc, building) => {
    const floors = building.floors?.filter(({ id }) => favoriteFloors.includes(id)) || []

    return [...buildingsAcc, ...floors]
  }, [])
}

const getCities = (item: IPortfolioRegion, favoriteFloors: string[]) => {
  return item.cities.reduce<IFloorDetails[]>((citiesAcc, city) => {
    return [...citiesAcc, ...getBuildings(city, favoriteFloors)]
  }, [])
}

export default getFavoriteFloorsFromRegions
